export default class {
  constructor(context) {
    // Set Context
    this._context = context;

    // Initialise component
    this.init();
  }

  init() {
    const hotel = JSON.parse(sessionStorage.getItem('currentHotel'));
    if (!hotel) return;
    const gaData = hotel.GA;
    const ga4Data = hotel.GA4;
    // GA3 event
    const gaDataStructure = {
      ecommerce: {
        detail: {
          products: gaData,
        },
      },
      event: 'detail',
    };
    dataLayer.push({ ecommerce: null });
    dataLayer.push(gaDataStructure);
    // GA4 event
    const ga4DataStructure = {
      ecommerce: {
        items: ga4Data,
      },
      event: 'view_item',
    };
    dataLayer.push({ ecommerce: null });
    dataLayer.push(ga4DataStructure);
  }
}
